import React from 'react';
import { node } from 'prop-types';
import { Box } from '@mui/material';

const Actions = ({ children }) => (
  <Box
    sx={{
      minHeight: '50px',
      p: '10px 20px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    {children}
  </Box>
);
Actions.propTypes = {
  children: node.isRequired,
};

export default Actions;
